import { List } from "../schema/list";

/**
 * Number of configured sources on a list, across every per-type array (drives the "Next" gating on
 * the source page). Extracted from ListEditSource.tsx (file-length ratchet). Note this counts
 * trackers (not their files) and includes customEvents — a wider set than getListSources renders.
 */
export const countListSources = (list: List | undefined): number => {
	if (!list) {
		return 0;
	}

	return (
		(list.maps?.length || 0) +
		(list.jobs?.length || 0) +
		(list.liCompanyActivity?.length || 0) +
		(list.csvEnrichments?.length || 0) +
		(list.customEvents?.length || 0) +
		(list.liEvents?.length || 0) +
		(list.liPeople?.length || 0) +
		(list.liPosts?.length || 0) +
		(list.liProfile?.length || 0) +
		(list.liProfileVisits?.length || 0) +
		(list.liSn?.length || 0) +
		(list.fundingMa?.length || 0) +
		(list.parallelAi?.length || 0) +
		(list.swarms?.length || 0) +
		(list.companyEnriches?.length || 0) +
		(list.trackers?.length || 0)
	);
};
